import { Stack } from '@mui/system';
import React from 'react';
import CeluIcon from '../CeluIcon';
import cartIcon from '../../../assets/icons/ecommerce/empty_search.svg'
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const NotFoundMessagePlaceholder = () => {

    const classes = useStyles()

    return ( 
        <div className={classes.root}>
            <Stack alignItems='center' spacing={2}>
                <CeluIcon icon={cartIcon} size='large'/>
                <Typography variant='body1' className={classes.text} align='center'>
                    {'No se encontraron resultados'}
                </Typography>
                <Typography variant='body2' className={classes.text} align='center'>
                    {'Por favor, intenta con otra búsqueda'}
                </Typography>
            </Stack>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        padding:'40px 16px'
    },
    text:{
        //maxWidth:200
    }
}))
 
export default NotFoundMessagePlaceholder;